































import Vue from 'vue'
import config from '@/utils/config'
import CimissDataService from '@/service/CimissDataService'
import warningImg from '@/utils/warningImg'
import request from '@/utils/request'
export default Vue.extend({
  mounted() {
    //@ts-ignore
    this.articleId = this.$route.query.id
    this.getData()
  },
  data() {
    return {
      articleId: "" as string,
      data: undefined as any
    }
  },

  methods: {

    getData() {
      request.get(`/api/column/rest_article/${this.articleId}`).then((data) => {
        this.data = data
        const categoryId = data.categoryId
        const title: string = data.title
        let level = ""
        let type = ""
        if (title.indexOf("红色") > -1) {
          level = "红色"
        } else if (title.indexOf("橙色") > -1) {
          level = "橙色"
        }
        if (title.indexOf("城市") > -1) {
          type = "城市"
        } else if (title.indexOf("乡镇") > -1) {
          type = "乡镇"
        }
        if (categoryId === "10") {
          this.data.imgUrl = warningImg.getWarnCategoryImg(level)
          //@ts-ignore
          document.title = '临灾警报'
        } else if (categoryId === "11") {
          this.data.imgUrl = "/static/warningIcon/warn_zhongyaojingshi.jpg"
          //@ts-ignore
          document.title = '重要警示'
        }
        this.data.fyzn = warningImg.getWarnCategoryFyzn(type + level)
        console.log(data)

      })
    },


  }
})
